import AdminLayout from "components/layout/AdminLayout"
import PageHeader from "components/restaurants/PageHeader"
import { ReactElement } from "react"
import Restaurants from "views/Restaurants"

const MyShops = () => {
  return (
    <>
      <PageHeader name="Betriebe verwalten" helpLink={"https://intercom.help/getpacked/de"} />
      <Restaurants />
    </>
  )
}

MyShops.getLayout = (page: ReactElement) => {
  return <AdminLayout>{page}</AdminLayout>
}

export default MyShops
